<template>
  <div class="cmbOrderList">
    <h1>订单信息</h1>
    <el-form :inline="true">
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFind()">查询</el-button>
          <!-- <el-button @click="resetSearchParam()">重置</el-button> -->
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="show.addShow = true">新增</el-button>
          <el-button type="warning" :disabled="show.selected.length < 1" @click="del()">删除</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item label="当前价格">
        <el-text type="danger">{{ data.cmbGoldPriceNow.buyPrice }}</el-text>
        <el-text> / </el-text>
        <el-text type="success">{{ data.cmbGoldPriceNow.salePrice }}</el-text>
      </el-form-item>
      <el-form-item label="持有">
        <el-text>{{ data.cmbGoldPriceNow.cmbGoldGram }}</el-text>
      </el-form-item>
      <el-form-item label="总收益">
        <el-text>{{ data.cmbGoldPriceNow.cmbGoldProfit }}</el-text>
      </el-form-item>
    </el-form>
    <el-table :data="data.cmbOrderList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column label="方式">
        <template #default="scope">
          <el-text type="danger" v-show="scope.row.gram > 0">买入</el-text>
          <el-text type="success" v-show="scope.row.gram < 0">卖出</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="交易价格" />
      <el-table-column prop="gram" label="克重" />
      <el-table-column prop="amount" label="金额" />
      <el-table-column prop="operateDatetime" label="操作时间" />
    </el-table>
    <div style="height: 10px;" />
  </div>

  <el-dialog v-model="show.addShow" title="新增订单" width="550" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="addCmbOrderParam" label-width="auto">
      <el-form-item label="交易时间">
        <el-date-picker v-model="addCmbOrderParam.operateDatetime" type="datetime" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="交易价格">
        <el-input-number :controls="false" :precision="2" v-model="addCmbOrderParam.price" style="width: 100%;" @change="computeAmount" />
      </el-form-item>
      <el-form-item label="克重">
        <el-input-number :controls="false" :precision="0" v-model="addCmbOrderParam.gram" style="width: 100%;" @change="computeAmount" />
      </el-form-item>
      <el-form-item label="金额">
        <el-input-number :controls="false" :precision="2" v-model="addCmbOrderParam.amount" style="width: 100%;" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="show.addShow = false">取消</el-button>
        <el-button type="primary" @click="commitAddCmbOrder()">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  cmbGoldPriceNow: {},
  cmbOrderList: [],
})

const show = reactive({
  addShow: false,
  selected: [],
})

// const searchParam = reactive({})
// const resetSearchParam = () => {
//   searchParam.pageNum = 1
//   searchParam.pageSize = 50
// }
// resetSearchParam()

const commitFind = () => {
  api.get('/backend/cmbGold/cmbGoldPriceNow').then(res => {
    data.cmbGoldPriceNow = res
  })
  api.get('/backend/cmbGold/getMyCmbGoldOrder').then(res => {
    data.cmbOrderList = res.list
  })
}
commitFind()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}


const addCmbOrderParam = reactive({})
const resetAddCmbOrderParam = () => {
  addCmbOrderParam.price = null
  addCmbOrderParam.gram = null
  addCmbOrderParam.amount = null
  addCmbOrderParam.operateDatetime = null
}
resetAddCmbOrderParam()

const computeAmount = () => {
  addCmbOrderParam.amount = math.multiply(addCmbOrderParam.price || 0, addCmbOrderParam.gram || 0, -1)
}

const commitAddCmbOrder = () => {
  api.post('/backend/cmbGold/addCmbGoldOrder', addCmbOrderParam).then(res => {
    ElMessage.success('新增成功')
    show.addShow = false
    commitFind()
    resetAddCmbOrderParam()
  })
}

const del = () => {
  const ids = tabRef.value.getSelectionRows().map(item => item.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的 ' + ids.length + ' 项。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    api.post('/backend/cmbGold/delMyCmbGoldOrder', { ids: ids }).then(() => {
      ElMessage.success('删除成功')
      commitFind()
    })
  })
}

</script>

<style lang="less"></style>